import GenericForm from 'components/GenericForm';
import type { GenericFormFields, SitecoreBlockProps } from 'models/sitecore';

interface Props extends SitecoreBlockProps {
	fields?: GenericFormFields;
}

export default function AccountJulaProAddUserForm({ fields }: Props) {
	if (!fields) {
		return null;
	}
	return (
		<div>
			<GenericForm
				formLocation="AccountJulaProAddUserForm"
				sections={fields.sections}
				errorView={fields.error}
				successView={fields.success}
				loadingView={fields.loading}
			/>
		</div>
	);
}
AccountJulaProAddUserForm.displayName = 'AccountJulaProAddUserForm_Partial';
